import { environment }                from '@env/environment';
import { IEnvironmentKeycloakConfig } from '@env/environment.model';

const getKeycloakConfig = (): IEnvironmentKeycloakConfig => {
	return environment.keycloak;
};

// tslint:disable-next-line:variable-name
export const BrandUtils = {
	getKeycloakConfig
};
